import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UploadAvatarRequest {
    originFileName: string;
    contentType: string;
}